import React, { PureComponent } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import classNames from "classnames";

export class DropDown extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]).isRequired,
    isOpen: PropTypes.bool.isRequired,
    className: PropTypes.string,
    contentClass: PropTypes.string,
    contentTag: PropTypes.string,
    footer: PropTypes.object,
    maxHeight: PropTypes.number,
    wrapperTag: PropTypes.string
  };

  static defaultProps = {
    className: "",
    contentClass: "",
    contentTag: "div",
    footer: {},
    maxHeight: null,
    wrapperTag: "div"
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.contentRef.current.scrollTop = 0;
    }
  }

  get wrapper() {
    const height = this.props.maxHeight ? "auto" : `${_.get(this.contentRef, "current.clientHeight") / 16}rem`;
    const maxHeight = this.props.maxHeight || "auto";

    return {
      style: !this.props.isOpen ? {} : { height, maxHeight },
      className: classNames(this.props.className, { "--open": this.props.isOpen })
    };
  }

  get contentProps() {
    const footerHeight = this.props.footer.height || 0;

    if (this.props.maxHeight) {
      return {
        style: { maxHeight: this.props.maxHeight - footerHeight },
        className: classNames("dropdown__content", this.props.contentClass, { "--scrollable": this.props.maxHeight })
      };
    }

    return {
      className: classNames("dropdown__content", this.props.contentClass, { "--scrollable": this.props.maxHeight })
    };
  }

  contentRef = React.createRef();

  render() {
    const WrapperTag = this.props.wrapperTag;
    const ContentTag = this.props.contentTag;

    return (
      <WrapperTag {...this.wrapper}>
        <ContentTag ref={this.contentRef} {...this.contentProps}>
          {this.props.children}
        </ContentTag>
        {this.props.footer.component && <this.props.footer.component />}
      </WrapperTag>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Common/DropDown.js